import { createSlice } from '@reduxjs/toolkit';
import {
  getSchedule,
  getScheduleById
} from 'src/services/scheduleService';

export const scheduleSlice = createSlice({
  name: 'schedules',
  initialState: {
    loading: false,
    schedules: [],
    tagsSchedule: [],
    errorMessage: '',
    currentPage: 1,
    totalPage: 1
  },
  reducers: {
    clearState: (state) => {
      state.schedules = [];
      state.tagsSchedule = [];
      state.errorMessage = '';
      state.currentPage = 1;
      state.totalPage = 1;
      state.loading = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getScheduleById.pending, (state) => {
      state.loading = true;
    }),
      builder.addCase(getScheduleById.fulfilled, (state, { payload }) => {
        state.tagsSchedule = payload;
        state.loading = false;
        return state;
      }),
      builder.addCase(getScheduleById.rejected, (state, { payload }) => {
        state.errorMessage = payload?.error;
        state.loading = false;
      }),
      builder.addCase(getSchedule.pending, (state) => {
        state.loading = true;
      }),
      builder.addCase(
        getSchedule.fulfilled,
        (state, { payload }) => {
          state.schedules = payload.data;
          state.currentPage = payload.current_page;
          state.totalPage = payload.last_page;
          state.loading = false;
          return state;
        }
      ),
      builder.addCase(
        getSchedule.rejected,
        (state, { payload }) => {
          state.errorMessage = payload?.error;
          state.loading = false;
        }
      );
  }
});

export const scheduleSelector = (state) => state.schedule;
export const reducer = scheduleSlice.reducer;
export const { clearState } = scheduleSlice.actions;
